import { Col, Row, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import { useEffect, useState } from "react";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";
import Spinner from "../../../commons/Spinner";

const TablePvPc111 = ({ selected, setSelected, deviceArr, deviceId }) => {
    const [pcsData, setPcsData] = useState(null);
    const authToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPcsData(null);
        setIsLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async (signal) => {
            const data = await getElectricityInfo(authToken, deviceId, selected, signal);
            if (!data || data === null || data.comm_error) {
                setPcsData({
                    real_power: "---",
                    ac_curr_phs_l1: "---",
                    ac_curr_phs_l2: "---",
                    ac_curr_phs_l3: "---",
                    ac_volt_phs_l1: "---",
                    ac_volt_phs_l2: "---",
                    ac_volt_phs_l3: "---",
                    dc_curr_pv1: "---",
                    dc_curr_pv2: "---",
                    dc_curr_pv3: "---",
                    dc_curr_pv4: "---",
                    dc_curr_pv5: "---",
                    dc_curr_pv6: "---",
                    dc_curr_pv7: "---",
                    dc_curr_pv8: "---",
                    dc_curr_pv9: "---",
                    dc_curr_pv10: "---",
                    dc_curr_pv11: "---",
                    dc_curr_pv12: "---",
                    dc_curr_pv13: "---",
                    dc_curr_pv14: "---",
                    dc_curr_pv15: "---",
                    dc_curr_pv16: "---",
                    dc_curr_pv17: "---",
                    dc_curr_pv18: "---",
                    dc_curr_pv19: "---",
                    dc_curr_pv20: "---",
                    dc_volt_pv1: "---",
                    dc_volt_pv2: "---",
                    dc_volt_pv3: "---",
                    dc_volt_pv4: "---",
                    dc_volt_pv5: "---",
                    dc_volt_pv6: "---",
                    dc_volt_pv7: "---",
                    dc_volt_pv8: "---",
                    dc_volt_pv9: "---",
                    dc_volt_pv10: "---",
                    dc_volt_pv11: "---",
                    dc_volt_pv12: "---",
                    dc_volt_pv13: "---",
                    dc_volt_pv14: "---",
                    dc_volt_pv15: "---",
                    dc_volt_pv16: "---",
                    dc_volt_pv17: "---",
                    dc_volt_pv18: "---",
                    dc_volt_pv19: "---",
                    dc_volt_pv20: "---",
                    device_id: selected.device_id,
                    error_code: "---",
                    freq: "---",
                    measured_time: "---",
                    power_factor: "---",
                    power_gene_str: "---",
                    time: "---",
                    work_status: "---",
                    event_code: "---",
                    event_signal: "---",
                    event_signal2: "---",
                    event_signal3: "---"
                })
            } else {
                setPcsData(data);
            } setIsLoading(false);
        };
        const interval = setInterval(() => {
            fetchData(signal);
        }, 60000);
        fetchData(signal);
        return () => {
            clearInterval(interval);
            controller.abort();
        };
        //eslint-disable-next-line
    }, [selected]);

    return (
        <>{isLoading ? <Spinner /> : <Row>
            <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
                <div>
                    <button
                        className="btn_back"
                        onClick={() => setSelected(null)}
                    >
                        <img src="/img/left.png" alt="leftArrow" />
                    </button>
                </div>
                <div className="vl">

                </div>
            </Col>
            <Col md={10} lg={10} sm={10} xl={11} className="col-9">
                <Row className="d-flex flex-row mx-1">
                    <div className="dropDown">
                        <select
                            type="select"
                            size="sm"
                            className="btn__dropdown"
                            value={selected.device_id}
                            onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
                        >
                            {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
                        </select>
                    </div>
                    <div className="batteryBox">
                        <div className="colBorder">
                            <Row className="justify-content-center"><img src="/img/pcsImage.png" alt="pv-pcs" className="pv-pcs py-1" />
                            </Row>
                            <Row className="mb-4 mt-4 justify-content-center">
                                {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                            </Row>
                        </div>
                    </div>
                    <Col md={8} sm={10} lg={7} className="individual-battery">
                        <div className="scroll-bar">
                            {(pcsData !== null) && <Table className="power__data">
                                <tbody>
                                    <tr>
                                        <td>累計発電量 </td>
                                        <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                                    </tr>
                                    <tr>
                                        <td>有効電力</td>
                                        <td>{formatPower(pcsData.real_power, 2)}</td>
                                    </tr>
                                    <tr>
                                        <td>力率</td>
                                        <td>{formatNumber(pcsData.power_factor, 3)}</td>
                                    </tr>
                                    <tr>
                                        <td>周波数</td>
                                        <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧1</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv1, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧2</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv2, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧3</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv3, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧4</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv4, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧5</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv5, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧6</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv6, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧7</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv7, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧8</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv8, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧9</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv9, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧10</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv10, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧11</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv11, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧12</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv12, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧13</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv13, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧14</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv14, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧15</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv15, 2)}V</td>
                                    </tr>

                                    <tr>
                                        <td>DC電圧16</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv16, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電圧17</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv17, 2)}V</td>
                                    </tr>

                                    <tr>
                                        <td>DC電圧18</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv18, 2)}V</td>
                                    </tr>

                                    <tr>
                                        <td>DC電圧19</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv19, 2)}V</td>
                                    </tr>

                                    <tr>
                                        <td>DC電圧20</td>
                                        <td>{formatNumber(pcsData.dc_volt_pv20, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流1 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv1, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流2</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv2, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流3 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv3, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流4</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv4, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流5 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv5, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流6</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv6, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流7 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv7, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流8</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv8, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流9 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv9, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流10</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv10, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流11 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv11, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流12</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv12, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流13 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv13, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流14</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv14, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流15 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv15, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流16</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv16, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流17 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv17, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流18</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv18, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流19 </td>
                                        <td>{formatNumber(pcsData.dc_curr_pv19, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>DC電流20</td>
                                        <td>{formatNumber(pcsData.dc_curr_pv20, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（A相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l1, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（B相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l2, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電圧（C相）</td>
                                        <td>{formatNumber(pcsData.ac_volt_phs_l3, 2)}V</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（A相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l1, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（B相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l2, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>系統電流（C相）</td>
                                        <td>{formatNumber(pcsData.ac_curr_phs_l3, 2)}A</td>
                                    </tr>
                                    <tr>
                                        <td>故障コード	</td>
                                        <td>{pcsData.event_code}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム1</td>
                                        <td>{pcsData.event_signal}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム2	</td>
                                        <td>{pcsData.event_signal2}</td>
                                    </tr>
                                    <tr>
                                        <td>アラーム3	</td>
                                        <td>{pcsData.event_signal3}</td>
                                    </tr>
                                </tbody>
                            </Table>}</div>
                    </Col>
                </Row>
            </Col>
        </Row>}
        </>
    );
};

export default TablePvPc111;
